export interface PendingOstUploadFile {
  id: string;
  ownerId: string;
  ostNum: string;
  batchId: string;
  fileName: string;
  originalName: string;
  content: Blob;
  type: string;
  size: number;
  lastModified: number;
  attemptCount: number;
  nextAttemptAt: number;
  lastError?: string;
}

export interface AwaitingOstUploadEventFile extends Omit<PendingOstUploadFile, "attemptCount" | "nextAttemptAt" | "lastError"> {
  deadlineAt?: number;
}

export interface OstUploadBatchRecord {
  id: string;
  ownerId: string;
  ostNum: string;
  fileIds: string[];
  fileNames: string[];
  acceptedFileIds: string[];
  confirmedFileIds: string[];
  createdAt: number;
  allAcceptedAt?: number;
  deadlineAt?: number;
  completedAt?: number;
  expiredAt?: number;
}

export interface ExpiredOstUploadFile {
  id: string;
  ownerId: string;
  ostNum: string;
  fileName: string;
  expiredAt: number;
}

export interface OstUploadNameReservation {
  id: string;
  ownerId: string;
  ostNum: string;
  fileName: string;
}

export interface OstUploadUsageDirtyRecord {
  id: string;
  ownerId: string;
  ostNum: string;
}

export interface OstUploadSuccessEvent {
  ostNum: string;
  fileName: string;
  fechaGeneracion: string;
}

export interface OstUploadStatus {
  hydrated: boolean;
  blocked: boolean;
  deliveryFileNames: string[];
  awaitingEventFileNames: string[];
  expiredFileNames: string[];
}

export const OST_UPLOAD_BACKEND_DEADLINE_MS = 30 * 60 * 1000;

export interface OstUploadOwnerContext {
  email?: string;
  country?: string;
  commerce?: string;
  storeCode?: string;
}

export async function createOstUploadOwnerId(owner: OstUploadOwnerContext): Promise<string | undefined> {
  const email = owner.email?.trim().toLowerCase();
  const country = owner.country?.trim().toUpperCase();
  const commerce = owner.commerce?.trim().toLowerCase();
  const storeCode = owner.storeCode?.trim().toLowerCase();
  if (!email || !country || !commerce) return undefined;

  const scope = JSON.stringify([country, commerce, storeCode ?? "", email]);
  if (typeof crypto === "undefined" || !crypto.subtle) return undefined;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(scope));
  const hash = Array.from(new Uint8Array(digest), (byte: number): string => byte.toString(16).padStart(2, "0")).join("");
  return `${country}:${commerce}:${hash}`;
}
